import OrchestratorAPI from './common.js';
import { type ApiInstanceFhirEndpoint } from '../models/orchestrator/apiInstanceFhir.js';

export default class API extends OrchestratorAPI {
  protected readonly API_PATH = '/api-instance-fhir-endpoints';
  public readonly baseEndpoint = `${this.BASE_URL}${this.API_PATH}`;

  async findOneById(id: string): Promise<ApiInstanceFhirEndpoint> {
    const url = this.constructPath(`/${id}`);
    const { apiInstanceFhirEndpoint } = await this.common.getJSON(url);
    return apiInstanceFhirEndpoint;
  }
}
